import DesignDetails from './design-details';

export default DesignDetails;
